import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useFavorites } from "@/hooks/useFavorites";
import { useSession } from "@/state/SessionProvider";
import { useNavigate } from "react-router-dom";

interface FavoriteButtonProps {
  listingId: string;
  variant?: "default" | "ghost";
}

export const FavoriteButton = ({ listingId, variant = "ghost" }: FavoriteButtonProps) => {
  const { user } = useSession();
  const navigate = useNavigate();
  const { isFavorite, addFavorite, removeFavorite } = useFavorites(user?.id);
  const favorited = isFavorite(listingId);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (!user) {
      navigate("/auth?mode=signin");
      return;
    }

    if (favorited) {
      removeFavorite(listingId);
    } else {
      addFavorite(listingId);
    }
  };

  return (
    <Button
      variant={variant}
      size="icon"
      onClick={handleClick}
      className="rounded-full"
    >
      <Heart
        className={`h-5 w-5 ${favorited ? "fill-red-500 text-red-500" : ""}`}
      />
    </Button>
  );
};
